<template>
    <div>
        <div class="company_dashboar_new">

            <!-- // -->
            <div class="ibox col-md-12 border-0 top_container_agent">
                <div class="ibox-title dashboard_title company-form-box-title ">
                    <div class="row no-gutters pb-4">
                        <div class="col-sm-6 float-left">
                            <div class="title-text pt-3">Welcome {{ agent_name }}</div>
                            <span style="color: #14457A;">Agent Dashboard</span>
                        </div>
                        <div class="col-sm-6 search_container">
                            <div class="row dashboard_overview_card_wrapper">


                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class=" col-sm-12">
                                            <div class="row dashboard_overview_card" style="background: #E1F2FF;">
                                                <div class="col-sm-10 first text-left">
                                                    <div class="sub-title" style="color: #4A698C;">Employees </div>
                                                    <div class="title" style="color: var(--primary-80, #1A5698);">{{
                                                        total_headcounts }}</div>
                                                </div>
                                                <div class="col-sm-2 second d-flex align-items-center ">
                                                    <div class="icon d-flex align-items-center">
                                                        <i class="fa fa-users"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class=" col-sm-12">
                                            <div class="row dashboard_overview_card" style="background: #E1F2FF;">
                                                <div class="col-sm-10 first text-left">
                                                    <div class="sub-title" style="color: #4A698C;">Companies</div>
                                                    <div class="title" style="color: var(--primary-80, #1A5698);">{{
                                                        companies.length }}</div>
                                                </div>
                                                <div class="col-sm-2 second d-flex align-items-center">
                                                    <div class="icon d-flex align-items-center">
                                                        <i class="far fa-building"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- // -->
            <div class=" col-md-12 border-0 module_link_container">  <!-- Abdullah added <div class=" col-md-12 border-0 module_link_container">. -->
                <div class="all-company-page">
                    <div class="card border-0 bg-wash no-shadow mt-5">
                        <!-- Abdullah added dialog-class="w-1200" -->
                        <b-modal dialog-class="w-1200" id="bv-modal-cs" size="lg" hide-footer title="Compliance Summary">
                            <ComplianceSummary :pageurl="this.$api_url"></ComplianceSummary> <!-- Abdullah added :pageurl="this.$api_url -->
                        </b-modal>
                    </div>
                    <div class="card border-0 bg-wash no-shadow mt-5">

                        <div class="card-header px-0 bg-transparent border-0">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ml-0 custom-search custom-search-agent mt-2">
                                        <b-input-group class="mb-0">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="search"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="search" placeholder="Search" v-model="search" @input="resetPagination()"></b-form-input>
                                        </b-input-group>
                                    </div>
                                </div>
                                <div class="col-md-6 text-right">
                                    <div class="pr-0">
                                        <!-- this button is for switcing between list and grid mode. class name viewmode for grid view -->

                                        <!-- Abdullah removed <b-icon v-if="showcs" class="ml-3" icon="x-circle"></b-icon><b-icon v-else class="ml-3" icon="eye-fill"></b-icon> -->
                                        <b-button class="mb-0 custom-wizard-btn" @click="showCS()">Compliance Summary</b-button>
                                        <b-button id="show-btn" v-if="ce" :href="$api_url+'/company/wizard'"><b-icon icon="plus" ></b-icon> Create Company</b-button>
                                        <!-- <b-button class="view-mode-btn employee-filter-btn mb-0" @click="viewmode = !viewmode">Switch View<b-icon v-if="showcs" class="ml-3" icon="grid3x3-gap-fill"></b-icon><b-icon v-else class="ml-3" icon="list-ul"></b-icon></b-button> -->
                                        <div class="d-inline-block directory-switch-btns align-top">
                                            <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                                :class="[{ 'active': viewmode }]" @click="viewmode = true"><b-icon
                                                class="grid" icon="grid"></b-icon></b-button>
                                            <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                                @click="viewmode = false" :class="[{ 'active': !viewmode }]"><b-icon
                                                class="list-icon" icon="list"></b-icon></b-button>
                                            <span class="view-mode-status d-block"><template v-if="viewmode">Grid
                                                    View</template><template v-else>List View</template></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

                        <b-overlay :show="showoverlay" rounded="sm">

                            <div class="card-body container-fluid pt-1 py-2 px-0">
                                <!-- grid view starts here -->
                                <div class="grid-view my-5 clearfix" v-if="viewmode">
                                    <div class="container-fluid px-0">
                                        <div class="grid clearfix">
                                            <!-- Abdullah added  @click="setCompany(company.id, 'company/dashboard')"-->
                                            <div class="grid-item px-0 pt-0 hover-bg card agent_employee_card reports-tab-nav" v-for="company in paginatedData" :key="company.id" @click="setCompany(company.id, 'company/dashboard')">
                                                <div class="grid-top-block">
                                                    <div class="company-title-block cursor-pointer mt-0 mb-2 " :class="company.company_packages_title">   <!-- Abdullah added this div with class company-title-block cursor-pointer mt-0 mb-2 -->
                                                        <div class="row pt-3">
                                                            <div class="col-md-12">
                                                                <div class="d-flex px-3">
                                                                    <div class="col-md-5 text-left text_white px-0">
                                                                        <!-- Abdullah added this line  -->
                                                                            {{company.name }}
                                                                        <!-- Abdullah commented this line  -->
                                                                        <!-- <div class="company-title-block cursor-pointer mt-0 mb-2 py-2" :class="company.company_packages_title" @click="setCompany(company.id , 'company/dashboard')">{{company.name}}</div> -->
                                                                    </div>
                                                                    <div class="col-md-7 float-right text-right pb-2 px-0">
                                                                        <div class="d-flex text-right float-right">
                                                                            <!-- <div class="cursor-pointer clearfix px-3">
                                                                                <div class="company-img-block float-left" @click="setCompany(company.id , 'company/dashboard')"><img v-bind:src="$api_url+'/images/company/' + company.logo"  class="" /></div>
                                                                                <div class="company-info-block float-right text-right">

                                                                                    <div class="company-info-block-bottom clearfix" @click="setCompany(company.id , 'company/dashboard')">
                                                                                        <div class="pl-0 pr-0" style="height: 31px;" v-on:click.stop><span class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon class="" icon="people-fill"></b-icon></span><span class="text-center px-2 border d-inline-block h-100 employee-count-number" style="min-width: 51px;">{{company.no_of_employees}}</span></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="cursor-pointer text-left mt-3 px-3" @click="setCompany(company.id , 'company/dashboard')">
                                                                                <span class="row"><span class="col-md-5 pr-0">Contact Name:</span> <span class="col-md-7 pl-0">{{company.contact_person}}</span></span>
                                                                                <span class="row"><span class="col-md-5 pr-0">Email:</span> <span class="col-md-7 pl-0">{{company.email}}</span></span>
                                                                                <span class="row"><span class="col-md-5 pr-0">Contact No:</span> <span class="col-md-7 pl-0">{{formatPhoneNumber(company.phone)}}</span></span>
                                                                            </div> -->
                                                                            <div class="pl-0 company-employee-count" style="height: 31px; position: unset;">
                                                                                <span class="text-center px-2 d-inline-block h-100 employee-count-icon employee-count-icon1">
                                                                                    <b-icon class="" icon="people-fill"></b-icon>
                                                                                </span>
                                                                                <span class="text-center px-2 pr-3 d-inline-block h-100 employee-count-number employee-count-number1" style="min-width: 51px;">{{ company.no_of_employees }}</span>
                                                                            </div>
                                                                            <div class="">
                                                                                <div class="active-badge px-1 agent_active pt-1 pr-2 d-flex justify-content-center align-items-center">
                                                                                    <b-icon class="ml-0 mr-1" icon="check-circle-fill" variant="success"></b-icon>Active
                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                <!-- Abdullah added this div with class class="col-md-12"  -->
                                                                <div class="col-md-12">
                                                                <!-- <h4>hi</h4> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="cursor-pointer growth_title"
                                                            :class="company.company_packages_title">

                                                            <div class="px-0 d-flex pt-3">
                                                                <div class="col-md-6 text-left">

                                                                    <b-button variant="primary"
                                                                        class="custom-secodary-btn btn-agent"
                                                                        @click="setCompany(company.id, 'company/dashboard')">
                                                                        Dashboard
                                                                    </b-button>
                                                                </div>
                                                                <div class="col-md-6 action">
                                                                    <!-- <div class="action">
                                                                        <b-button-toolbar
                                                                            class="float-right position-relative">
                                                                            <a id="actionDropdown"
                                                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                                                style="font-size: 16px;" href="#"
                                                                                role="button" data-toggle="dropdown"
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"><b-icon
                                                                                    icon="three-dots-vertical"></b-icon></a>
                                                                            <div class="dropdown-menu action-dropdown-menu"
                                                                                aria-labelledby="actionDropdown">
                                                                                <b-button-group class="mt-n2">
                                                                                    <b-button class="border-0 rounded py-0"
                                                                                        variant="outline-secondary"
                                                                                        title="Edit spouse Info"
                                                                                        >
                                                                                        <b-icon icon="pencil-fill"
                                                                                            aria-hidden="true"></b-icon>
                                                                                        Edit
                                                                                    </b-button>
                                                                                    <b-button class="border-0 rounded py-0"
                                                                                        variant="outline-secondary"
                                                                                        title="Delete spouse Info"
                                                                                        >
                                                                                        <b-icon icon="trash"
                                                                                            aria-hidden="true"></b-icon>
                                                                                        Delete
                                                                                    </b-button>
                                                                                </b-button-group>
                                                                            </div>
                                                                        </b-button-toolbar>
                                                                    </div> -->
                                                                    <b-button-toolbar class="float-right position-relative">
                                                                        <a id="actionDropdown"
                                                                            class="dropdown-toggle clearfix action-dropdown-toggle backgroun_round"
                                                                            style="font-size: 16px;" href="#" role="button"
                                                                            data-toggle="dropdown" aria-haspopup="true"
                                                                            aria-expanded="false"><b-icon
                                                                                icon="three-dots"></b-icon></a>
                                                                        <div class="dropdown-menu action-dropdown-menu agent_drope_menu"
                                                                            aria-labelledby="actionDropdown">
                                                                            <b-button-group class="mt-n2 item_button">
                                                                                <b-button class="border-0  py-0"
                                                                                    variant="outline-secondary"
                                                                                    title="Dashboard"
                                                                                    @click="setCompany(company.id, 'company/dashboard')">
                                                                                    Dashboard
                                                                                </b-button>
                                                                                <b-button class="border-0  py-0"
                                                                                    variant="outline-secondary"
                                                                                    title="Employees" v-if="ce"
                                                                                    @click="setCompany(company.id, 'employee')">
                                                                                    Employees
                                                                                </b-button>
                                                                                <b-button class="border-0  py-0"
                                                                                    variant="outline-secondary"
                                                                                    title="Renew"
                                                                                    :href="'http://www.atlhr.com/customer-login/?s_key=' + company.sync_key + '&cmp_id=' + company.id + '&redirect=http://www.atlhr.com/pricing/'"
                                                                                    target="_blank"> Renew
                                                                                </b-button>
                                                                                <b-button class="border-0  py-0"
                                                                                    variant="outline-secondary"
                                                                                    title="Payruns" v-if="ce"
                                                                                    @click="setCompany(company.id, 'payruns')">
                                                                                    Payruns
                                                                                </b-button>
                                                                                <template
                                                                                    v-if="company.no_of_employees == 0">
                                                                                    <b-button variant="outline-secondary"
                                                                                        class="border-0  py-0" v-if="ce"
                                                                                        @click="passConfirm('deleteCompany', company.id)">
                                                                                        Delete
                                                                                    </b-button>
                                                                                </template>
                                                                            </b-button-group>
                                                                        </div>
                                                                    </b-button-toolbar>
                                                                </div>
                                                            </div>


                                                            <div class="cursor-pointer clearfix px-3 py-3">
                                                                <div class="company-img-block image_center" @click="setCompany(company.id, 'company/dashboard')">
                                                                    <div class="justify-content-center">
                                                                        <img v-bind:src="$api_url + '/images/company/' + company.logo" class="" />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="cursor-pointer text-left mt-3 px-3 font_size_responsive"
                                                    @click="setCompany(company.id, 'company/dashboard')">
                                                    <span class="row">
                                                        <span class="col-md-5 pr-0">Contact Name:</span>
                                                        <span class="col-md-7 pl-0 text_black"> {{ company.contact_person }}</span>
                                                    </span>

                                                    <span class="row">
                                                        <span class="col-md-5 pr-0">Email:</span>
                                                        <span class="col-md-7 pl-0 text_black">{{ company.email }}</span>
                                                    </span>

                                                    <span class="row">
                                                        <span class="col-md-5 pr-0">Contact No:</span>
                                                        <span class="col-md-7 pl-0 text_black">{{ formatPhoneNumber(company.phone) }}</span>
                                                    </span>

                                                </div>
                                                <!-- Abdullah chnaged class here. was cursor-pointer text-left px-3 -->
                                                <div style="" class="cursor-pointer mt-3 mb-0 px-3 height_responsive">

                                                    <!-- Abdullah commented this line  -->
                                                    <!-- <p v-if="company.company_packages_title">Package &amp; Add-ons</p> -->

                                                    <!-- Abdullah added this block of code  -->
                                                    <div class="border-top">
                                                        <h5 class="text-center text_black pt-2"
                                                            v-if="company.company_packages_title">Add-ons:</h5>
                                                    </div>

                                                     <!-- Abdullah made  justify-content-center from  justify-content-end -->
                                                    <div class="row justify-content-center">

                                                        <!-- Abdullah chnaged class here. was col-8 pr-0  -->
                                                        <div class="col-md-12" v-if="company.company_packages_title">
                                                            <!-- Abdullah chnaged class here. was clearfix px-0 text-left mb-3  -->
                                                            <div class="clearfix px-0 text-center mb-0 px-4">


                                                                <!-- Abdullah commented this  -->
                                                                <!-- <div v-if="company.company_packages_title" class="px-0"><span class="d-inline-block px-3 py-1 package-wrapper"><img v-bind:src="$api_url+'/images/package/growth.png'" v-if="company.company_packages_title == 'Growth'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/growth-light.png'" v-if="company.company_packages_title == 'Growth'"  class="img-fluid mr-2 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/corporate.png'" v-if="company.company_packages_title == 'Corporate'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/corporate-light.png'" v-if="company.company_packages_title == 'Corporate'"  class="img-fluid mr-2 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/enterprise.png'" v-if="company.company_packages_title == 'Enterprise'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/enterprise-light.png'" v-if="company.company_packages_title == 'Enterprise'"  class="img-fluid mr-2 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/lite.png'" v-if="company.company_packages_title == 'Lite'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/lite-light.png'" v-if="company.company_packages_title == 'Lite'"  class="img-fluid mr-2 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/strartup.png'" v-if="company.company_packages_title == 'Startup'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/strartup-light.png'" v-if="company.company_packages_title == 'Startup'"  class="img-fluid mr-2 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/open-pkg.png'" v-if="company.company_packages_title == 'Open'"  class="img-fluid mr-2 dark-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/open-pkg-light.png'" v-if="company.company_packages_title == 'Open'"  class="img-fluid mr-2 light-mode-icon" height="" width="" />{{company.company_packages_title}}</span></div>
                                                                <div class="px-0" v-else><span class="d-inline-block px-3 py-1 package-wrapper"><b-icon class="mr-2" icon="exclamation-triangle-fill" ></b-icon>No Package</span></div>
                                                                <ul class="company-addon-list" v-if="company.company_addons">
                                                                    <li v-for="c_addon in company.company_addons"><img v-bind:src="$api_url+'/images/package/icon-addon-light.png'" class="img-fluid mr-2 mt-n1 light-mode-icon" height="" width="" /><img v-bind:src="$api_url+'/images/package/icon-addon.png'" class="img-fluid mr-2 mt-n1 dark-mode-icon" height="" width="" /><span v-if="c_addon == 'Pf'">Provident Fund</span><span v-if="c_addon == 'LeaveAttendances'">Leave &amp; Attendance</span></li>
                                                                </ul> -->

                                                                <!-- Abdullah added this code  -->
                                                                <div class="ml-2 pl-2 ">
                                                                    <div class="active-badge px-1 agent_active pt-2 background_transparent"
                                                                        v-for="(c_addon, index) in company.company_addons"
                                                                        :key="index">
                                                                        <div class="rounded border py-1 px-2">
                                                                                <span class="agent_font_size"
                                                                                    v-if="c_addon === 'Pf'">
                                                                                    <img v-bind:src="$api_url + '/images/providentfund.png'"
                                                                                        class="img-fluid mr-2 mt-n1 light-mode-icon"
                                                                                        height="" width="" />
                                                                                    Provident Fund</span>
                                                                                <span class="agent_font_size"
                                                                                    v-if="c_addon === 'LeaveAttendances'">
                                                                                    <img v-bind:src="$api_url + '/images/leaveattendance.png'"
                                                                                        class="img-fluid mr-2 mt-n1 light-mode-icon"
                                                                                        height="" width="" />

                                                                                    Leave &amp; Attendance</span>
                                                                                <span class="agent_font_size"
                                                                                    v-if="c_addon === 'Gf'">
                                                                                    <img v-bind:src="$api_url + '/images/LoanAdvanceIcon.png'"
                                                                                        class="img-fluid mr-2 mt-n1 light-mode-icon"
                                                                                        height="" width="" />
                                                                                        Gratuity Fund</span>

                                                                                <!-- Abdullah added roster. need to ask sir before giving it to server  -->
                                                                                <span class="agent_font_size"
                                                                                    v-if="c_addon === 'Roster'">
                                                                                    <img v-bind:src="$api_url + '/images/leaveattendance.png'"
                                                                                        class="img-fluid mr-2 mt-n1 light-mode-icon"
                                                                                        height="" width="" />
                                                                                       Roster</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-4">
                                                            <span class="d-block text-center" v-if="company.package_expiry_date">{{company.package_expiry_date | formatDate}}</span>
                                                            <span class="company-renew-btn"><b-button variant="primary" :href="'http://www.accordhrm.com/customer-login/?s_key='+company.sync_key+'&cmp_id='+company.id+'&redirect=http://www.accordhrm.com/pricing/'" target="_blank" class="package-renew-button" >  Renew  </b-button></span>
                                                        </div> -->
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <div class="list-view employee-table-wrapper" v-else>
                                    <div class="reports-tab-nav">
                                        <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table">
                                            <thead>
                                                <tr class="table-head">
                                                    <td>Company</td>
                                                    <td>Employees</td>
                                                    <td>Contact info</td>
                                                    <td>Package &amp; Add-ons</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="hover-bg table-row border-bottom mx-2"
                                                    v-for="company in paginatedData" :key="company.id">
                                                    <td class="align-middle list-columns">
                                                        <!-- <div style="position: unset;" class="col-sm-6 py-2 cursor-pointer"
                                                            @click="setCompany(company.id, 'company/dashboard')">
                                                            <div class="active-badge rounded px-1"
                                                                v-if="company.company_packages_title">
                                                                Active</div>
                                                            <div class="active-badge inactive-badge rounded px-1" v-else>No
                                                                Package
                                                            </div>
                                                            <img v-bind:src="$api_url + '/images/company/' + company.logo"
                                                                class="img-fluid img-thumbnail" width="100px" />
                                                        </div> -->
                                                        <div class="cursor-pointer trz_relative"
                                                            @click="setCompany(company.id, 'company/dashboard')">
                                                            <label class="mb-0 custom-label d-flex align-items-center text-center">
                                                                <img v-bind:src="$api_url + '/images/company/' + company.logo"
                                                                class="img-fluid img-thumbnail employee-avatar mx-2" width="100px" />
                                                                <span class="cursor-pointer"> {{ company.name }}</span>
                                                            </label>


                                                        </div>
                                                    </td>
                                                    <!-- <td class="col-md-5 align-middle list-columns">
                                                        <div style="position: unset;" class="col-sm-6 py-2 cursor-pointer"
                                                            @click="setCompany(company.id, 'company/dashboard')">
                                                            <img v-bind:src="$api_url + '/images/company/' + company.logo"
                                                                class="img-fluid img-thumbnail" width="100px" />
                                                        </div>
                                                        <div class="col-sm-6 p-0 align-self-center cursor-pointer"
                                                            @click="setCompany(company.id, 'company/dashboard')">
                                                            {{ company.name }}
                                                        </div>
                                                    </td> -->
                                                    <td class=" align-middle list-columns">{{ company.no_of_employees }}
                                                        <!-- <a href="javascript:void(0)">{{ company.no_of_employees }}</a> -->
                                                    </td>
                                                    <td class=" align-middle list-columns">
                                                        <div v-if="company.contact_person" class=""><b-icon icon="person"
                                                                aria-hidden="true"></b-icon> {{ company.contact_person }}
                                                        </div>
                                                        <div class=""><b-icon icon="envelope" aria-hidden="true"></b-icon>
                                                            {{
                                                                company.email }}
                                                        </div>
                                                        <div class=""><b-icon icon="phone" aria-hidden="true"></b-icon>
                                                            {{ formatPhoneNumber(company.phone) }}</div>
                                                    </td>
                                                    <td class=" align-middle list-columns">
                                                        <span class="d-inline-block px-3 py-1 package-wrapper"
                                                            v-if="company.company_packages_title"><img
                                                                v-bind:src="$api_url + '/images/package/growth.png'"
                                                                v-if="company.company_packages_title == 'Growth'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/growth-light.png'"
                                                                v-if="company.company_packages_title == 'Growth'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/corporate.png'"
                                                                v-if="company.company_packages_title == 'Corporate'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/corporate-light.png'"
                                                                v-if="company.company_packages_title == 'Corporate'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/enterprise.png'"
                                                                v-if="company.company_packages_title == 'Enterprise'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/enterprise-light.png'"
                                                                v-if="company.company_packages_title == 'Enterprise'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/lite.png'"
                                                                v-if="company.company_packages_title == 'Lite'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/lite-light.png'"
                                                                v-if="company.company_packages_title == 'Lite'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/strartup.png'"
                                                                v-if="company.company_packages_title == 'Startup'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/strartup-light.png'"
                                                                v-if="company.company_packages_title == 'Startup'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/open-pkg.png'"
                                                                v-if="company.company_packages_title == 'Open'"
                                                                class="img-fluid mr-2 dark-mode-icon" height=""
                                                                width="" /><img
                                                                v-bind:src="$api_url + '/images/package/open-pkg-light.png'"
                                                                v-if="company.company_packages_title == 'Open'"
                                                                class="img-fluid mr-2 light-mode-icon" height=""
                                                                width="" />{{
                                                                    company.company_packages_title }}</span>

                                                        <ul class="company-addon-list" v-if="company.company_addons">
                                                            <li v-for="c_addon in company.company_addons"><img
                                                                    v-bind:src="$api_url + '/images/package/icon-addon-light.png'"
                                                                    class="img-fluid mr-2 mt-n1 light-mode-icon" height=""
                                                                    width="" /><img
                                                                    v-bind:src="$api_url + '/images/package/icon-addon.png'"
                                                                    class="img-fluid mr-2 mt-n1 dark-mode-icon" height=""
                                                                    width="" /><span v-if="c_addon == 'Pf'">Provident
                                                                    Fund</span><span
                                                                    v-if="c_addon == 'LeaveAttendances'">Leave &amp;
                                                                    Attendance</span>
                                                            </li>
                                                        </ul>
                                                        <span class="d-block pl-1">{{ company.package_expiry_date |
                                                            formatDate }}</span>
                                                    </td>
                                                    <td class=" align-middle list-columns text-right">
                                                        <a id="actionDropdown"
                                                            class="dropdown-toggle clearfix action-dropdown-toggle"
                                                            style="font-size: 16px;" href="#" role="button"
                                                            data-toggle="dropdown" aria-haspopup="true"
                                                            aria-expanded="false"><b-icon
                                                                icon="three-dots-vertical"></b-icon></a>
                                                        <div class="dropdown-menu action-dropdown-menu top_auto"
                                                            aria-labelledby="actionDropdown">
                                                            <b-button-group>
                                                                <b-button variant="outline-secondary" v-if="ce"
                                                                    @click="setCompany(company.id, 'employee')"
                                                                    >
                                                                    <b-icon icon="people-fill"></b-icon>Employees
                                                                </b-button>
                                                                <b-button variant="outline-secondary"
                                                                    @click="setCompany(company.id, 'company/dashboard')"
                                                                    >
                                                                    <b-icon icon="house-door-fill"></b-icon>Dashboard
                                                                </b-button>
                                                                <b-button variant="outline-secondary" v-if="ce"
                                                                    @click="setCompany(company.id, 'payruns')"
                                                                    >
                                                                    <b-icon
                                                                        icon="file-earmark-bar-graph-fill"></b-icon>Payruns
                                                                </b-button>
                                                                <template v-if="company.no_of_employees == 0">
                                                                    <b-button variant="outline-secondary" v-if="ce"
                                                                        @click="deleteCompany(company.id)"
                                                                        >
                                                                        Delete
                                                                    </b-button>
                                                                </template>
                                                            </b-button-group>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- pagination block -->
                                <div class="row py-2 float-right no-margin" v-if="paginatedData.length > 0">
                                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                                </div>
                                <!-- empty message block -->
                                <div class="row py-2 no-margin justify-content-center" v-if="paginatedData.length == 0">
                                    {{blankmsg}}
                                </div>
                            </div>
                        </b-overlay>
                    </div>
            </div>
            <template v-if="showpassconfirm">
                <pass-confirm-form   :the_id="this.the_id" :fun_name="this.fun_name"></pass-confirm-form>
            </template>
            </div>

        </div>
    </div>
</template>


<script>
    import moment from 'moment';
    export default{

        mounted() {

        },
        props: ['switch_view'],
        components: {

        },
        data(){

            return {

                cu:window.location.href,
                ce:false,
                notice: "No company has been created yet! Please create your company first!",
                pagetitle: 'Companies',
                search:'',
                companies:[],
                tax_zone:[],
                successmsg:'',
                errormsg:[],
                blankmsg : 'Hold your breath, we are currently fetching your company list ...',
                fdata: {status:null , id:null , city:null , tax_zone:null},
                file: null,
                new_capability:true,
                uflg : 1,
                agent_name:null,

                showoverlay :true,
                viewmode :true,
                showcs :false,

                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],
                city: [
                    { value: null, text: "Select..." },
                    { value: "Dhaka", text: "Dhaka" },
                    { value: "Chattogram", text: "Chattogram" },
                    { value: "Khulna", text: "Khulna" },
                    { value: "Rajshahi", text: "Rajshahi" },
                    { value: "Rangpur", text: "Rangpur" },
                    { value: "Sylhet", text: "Sylhet" },
                    { value: "Barishal", text: "Barishal" },
                    { value: "Gazipur", text: "Gazipur" },
                    { value: "Bogura", text: "Bogura" },
                    { value: "Cumilla", text: "Cumilla" },
                    { value: "Mymensingh", text: "Mymensingh" },
                ],

                listed_companies : 0,
                total_headcounts : 0,
                total_companies : 0,
                compliance_placeholder : 'N/A',
                comppany_pkg_title : '',

                length: 12,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},


                showpassconfirm : false,
                fun_name : '',
                the_id : '',
            }
        },
        filters:{
            formatDate: function(value){
                if (value && value != '0000-00-00 00:00:00') {
                    return moment(String(value)).format('DD MMM YYYY')
                }else{
                    value = '';
                }
            },
        },
        methods:{
            showCS: function()
            {
                this.$bvModal.show('bv-modal-cs');
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
            getCompanyData: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/company/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.showoverlay = false;

                    if(response.data.error == 1)
                        this.notice = response.data.notice;
                    else
                    {
                        //console.log(response.data);

                        this.companies = response.data.companies;
                        this.listed_companies = this.companies.length;
                        this.comppany_pkg_title = this.companies.company_packages_title;
                        console.log(this.companies);

                        let total_headcounts = 0;

                        for (let [key, value] of Object.entries(this.companies))
                        {
                            total_headcounts = total_headcounts + value.no_of_employees;
                            //console.log(value.no_of_employees);
                        }
                        this.total_headcounts = total_headcounts;

                        if(this.companies.length == 0)
                            this.blankmsg = "No company has been created yet! Please create your company first!";

                        this.uflg = response.data.uflg;
                    }

                }.bind(this));
            },

            passConfirm : function(fun_name , x)
            {
                this.fun_name = fun_name;
                this.the_id = x;
                this.showpassconfirm = true;
            },
            deleteCompany : function(id)
            {
                this.showpassconfirm = false;
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('id', id);
                axios.post(this.$api_url+'/company/delete', formData)
                                .then(function (response)
                                {

                                    if(response.data.status)
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                        setTimeout(function () {location.reload();  }.bind(this), 1000);
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                            title: `Warning`,
                                            variant: 'warning',
                                            solid: true
                                        });
                                    }
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },

            setCompany:function(x , y)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('company_id', x);
                axios.post(this.$api_url+'/company/setcompany', formData)
                                .then(function (response)
                                {
                                    window.location.href = this.$api_url+'/'+y;

                                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },

            getTaxZone: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/taxzone' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){

                    this.tax_zone = [{ value: null, text: "Select..." } ] . concat(response.data);
                }.bind(this));
            },

            checkCapability:function()
            {
                if(!this.checkNet()) return false;
                this.successmsg = null;
                axios.get(this.$api_url+'/company/capabilities' , {
                    params: {
                        action: 'addnew'
                    }
                }).then(function(response){
                  this.new_capability = response.data.capability;
                  if(response.data.capability == false){
                    this.errormsg = [];
                    this.errormsg[0] = ["You are not allowed to add more company!!!"];
                  }
                  else
                  this.errormsg = [];

                }.bind(this));
            },
            getCurrentAgent: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/publicinfo' , {
                    params: {

                    }
                }).then(function(response){
                    console.log(response.data);
                    this.agent_name = response.data.name;
                }.bind(this));
            },

        },
        created: function(){

            /*var this$api_url = this.$api_url + '/';
            if(this$api_url == window.location.href)
            {
                this.pagetitle = 'Dashboard';
            }*/

            this.getAcl();
            this.getCompanyData();
            this.getTaxZone();
            this.getCurrentAgent();
            Fire.$on('reloadUsers', () => {this.getCompanyData()})
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.companies;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                            this.blankmsg = "No company has been created yet! Please create your company first!";
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
        }
    }
</script>
